import { useState } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import Modal from '../ui/Modal';
import VerificareDocument from './VerificareDocument';

const INTREBARE_PROFESOR = 'Sunteți sigur că fișierul conține datele corecte și este semnat de către ambele părți?';

// profesorul incarca cererea semnata de ambele parti, dupa previzualizare si confirmare
function ModalIncarcareSemnata({ student, cerere, profesor, onInchide, onSucces }) {
    const SERVER = process.env.REACT_APP_SERVER;
    const [file, setFile] = useState(null);
    const [confirmat, setConfirmat] = useState(false);
    const [seIncarca, setSeIncarca] = useState(false);

    const onFileChange = e => {
        const ales = e.target.files[0];
        setFile(null);
        if (!ales) return;
        if (ales.size / 1024 / 1024 > 15) {
            toast.error('Fișierul este prea mare! Dimensiunea maximă este 15 MB.');
            e.target.value = null;
            return;
        }
        if (!ales.name.toLowerCase().endsWith('.pdf')) {
            toast.error('Puteți încărca doar fișiere PDF!');
            e.target.value = null;
            return;
        }
        setFile(ales);
    };

    const incarca = () => {
        const fileReader = new FileReader();
        fileReader.onload = async e => {
            setSeIncarca(true);
            try {
                const res = await fetch(SERVER + 'cerere', {
                    method: 'PATCH',
                    headers: {
                        Authorization: localStorage.getItem('token'),
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ fisier: e.target.result, idStudent: student.id }),
                });
                const data = await res.json();
                if (!res.ok) {
                    toast.error(data.error || data.message || 'Cererea nu a putut fi încărcată!');
                    return;
                }
                toast.success('Cererea semnată a fost încărcată cu succes!');
                onSucces();
            } catch (err) {
                toast.error('Cererea nu a putut fi încărcată!');
            } finally {
                setSeIncarca(false);
            }
        };
        fileReader.readAsDataURL(file);
    };

    return (
        <Modal lung open={true} closed={onInchide}>
            <Grid item xs={12} sm={12} md={12}>
                <Typography align="center" component="h5" variant="h5" sx={{ mb: 2 }}>
                    Încărcați cererea semnată a studentului {student.nume + ' ' + student.prenume}
                </Typography>
                <Typography align="center" sx={{ mb: 1 }}>
                    Titlul cererii: „{cerere?.titlu}”. Documentul trebuie să fie semnat de ambele părți.
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <input type="file" accept="application/pdf,.pdf" onChange={onFileChange} style={{ margin: '12px 0' }} />
                    <Box sx={{ width: '100%', maxWidth: 560 }}>
                        {file && (
                            <VerificareDocument
                                fisier={file}
                                student={student}
                                profesor={profesor}
                                titlu={cerere?.titlu}
                                rol="profesor"
                                intrebare={INTREBARE_PROFESOR}
                                onConfirmare={setConfirmat}
                            />
                        )}
                    </Box>
                    <Button variant="contained" color="success" disabled={!file || !confirmat || seIncarca}
                        sx={{ width: '45%', m: 1, mt: 3 }} onClick={incarca}>
                        {seIncarca ? 'Se încarcă...' : 'Încarcă'}
                    </Button>
                    <Button color="error" variant='outlined' sx={{ width: '45%', m: 1 }} onClick={onInchide}>
                        Nu încă
                    </Button>
                </Box>
            </Grid>
        </Modal>
    );
}

export default ModalIncarcareSemnata;
